<template>
  <div>
    <!-- <auto-logout/> -->
    <ContentHeader title="Robot List" />
    <table-skeleton v-if="loading">
      <b-skeleton type="input" class="rounded-pill btn" width="100px" style="cursor: wait;"></b-skeleton>
    </table-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <router-link
                  :to="{ name: 'AddRobot' }"
                  class="btn btn-success rounded-pill add-button"
                  ><i class="fas fa-plus mr-2"></i>Add Robot</router-link
                >

                <div class="d-flex filter-container">
                  <select
                    class="form-select mr-3 w-25 select-perpage"
                    v-model="table.perPage"
                  >
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </select>
                  <input
                    type="text"
                    name="search"
                    class="form-control w-75 search-bar"
                    placeholder="Search"
                    v-model="table.filter"
                  />
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="robots"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  :filter-included-fields="['name']"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template v-slot:cell(image)="data">
                    <img
                      class="img-fluid img-thumbnail"
                      style="width: 150px; min-width: 150px"
                      :src="data.item.image"
                      v-if="data.item.image"
                    />
                    <span v-else class="badge badge-pill badge-danger"
                      >NO IMAGE</span
                    >
                  </template>
                  <template v-slot:cell(strategy)="data">
                    <div style="min-width: 300px">
                      <div v-for="(itm,index) in data.item.strategy.split(';')" :key="itm">
                        <h6 class="" v-if="index == 0">Strategy</h6>
                        <h6 class="" v-if="index == 1">Deskripsi</h6>
                        <h6 class="" v-if="index == 2">Robot Type</h6>
                        <h6 class="" v-if="index == 3">Recommended Lot Size</h6>
                        <h6 class="" v-if="index == 4">Recommended Active Pair</h6>
                        <h6 class="" v-if="index == 5">Recommended Pair Option</h6>
                        <div v-if="index !== 3 && index !== 5" v-html="itm ? itm : '-'"></div>
                        <p v-if="index == 3 && itm"><span class="badge bg-dark me-1" v-for="ls in itm.split(',')" :key="ls">{{ls}}</span></p>
                        <p v-if="index == 5 && itm"><span class="badge bg-dark me-1" v-for="po in itm.split(',')" :key="po">{{po}}</span></p>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(risk_level)="data">
                    <span
                      v-if="!data.item.risk_level"
                      class="badge badge-pill badge-danger"
                      >RISK NOT SET</span
                    >
                    <span
                      v-else-if="data.item.risk_level == 1"
                      class="badge badge-pill badge-success"
                      >LOW</span
                    >
                    <span
                      v-else-if="data.item.risk_level == 2"
                      class="badge badge-pill badge-warning"
                      >MEDIUM</span
                    >
                    <span
                      v-else-if="data.item.risk_level == 3"
                      class="badge badge-pill badge-danger"
                      >HIGH</span
                    >
                  </template>
                  <template v-slot:cell(trade_report_file)="data">
                    <span
                      v-if="!data.item.trade_report_file"
                      class="badge badge-pill badge-danger"
                      >NO FILE YET</span
                    >
                    <a
                      v-else
                      :href="`${data.item.trade_report_file}`"
                      class="badge badge-pill badge-primary px-3 py-2"
                      download
                      >
                      <i class="fa fa-download me-1 p2"/>
                      DOWNLOAD FILE
                    </a>
                  </template>
                  <template v-slot:cell(Action)="data">
                    <router-link
                      :to="{
                        name: 'RobotDetails',
                        params: { id: data.item.id },
                      }"
                      class="mr-3"
                    >
                      <i class="fas fa-robot"></i>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'UpdateRobot',
                        params: { id: data.item.id },
                      }"
                      class="mr-3"
                    >
                      <i class="fas fa-edit text-warning"></i>
                    </router-link>
                    <a href="#" @click="deleteItem(data.item.id)">
                      <i class="fas fa-trash-alt text-danger"></i>
                    </a>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue"
import ContentHeader from "@/components/molecules/ContentHeader.vue";
// import AutoLogout from "@/components/organisms/AutoLogout.vue";
import apiClient from "../../services/ApiServices";

export default {
  components: {
    ContentHeader,
    TableSkeleton,
    // AutoLogout
  },

  data() {
    return {
      loading: true,
      robots: [],
      details: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "name",
            sortable: true,
          },
          {
            key: "image",
            sortable: false,
          },
          {
            key: "strategy",
            sortable: false,
          },
          {
            key: "risk_level",
            sortable: false,
          },
          {
            key: "trade_report_file",
            sortable: false,
          },
          "Action",
        ],
      },
    };
  },
  async mounted() {
    try {
      await apiClient.get(`?vendor_id=${this.$user_id}&without_broker=true`).then((res)=>{
        this.robots = res.data.data.sort(function (a, b) {
        return (
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
      });
      this.details = this.robots.split(',')
      this.table.totalRows = this.robots.length;
      })


    } catch (err) {
      // this.$toasted.show(error.message, {
      //   theme: "toasted-primary",
      //   position: "top-right",
      //   duration: 4000,
      // });
    } finally {
      this.loading = false
    }
  },

  methods: {
    deleteItem(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await apiClient.delete(`${id}`);
            this.robots = this.robots.filter((item) => item.id != id);
          } catch (error) {
            this.$toasted.show(error.message, {
              theme: "toasted-primary",
              position: "top-right",
              duration: 4000,
            });
          }

          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 601px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
  .filter-container {
    width: 100%;
    flex-direction: column !important;
  }
  .search-bar,
  .select-perpage {
    margin-bottom: 0.75rem;
    width: 100% !important;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
</style>
